import { render, staticRenderFns } from "./FeeWriteoff.vue?vue&type=template&id=c7ca96a2"
import script from "./FeeWriteoff.vue?vue&type=script&lang=js"
export * from "./FeeWriteoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports